import React, { useState } from "react";
import { Phone, X, ChevronDown, ChevronUp } from "lucide-react";
import logo from "../img/logo.png";

const Header = () => {
  const [showServices, setShowServices] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const navigateTo = (path) => {
    window.location.href = path;
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  return (
    <>
      <div className="hob-top-header">
        <div className="hob-top-header__contacts">
          <span
            onClick={() => (window.location.href = "tel:8433630912")}
            style={{ cursor: "pointer" }}
          >
            <Phone size={16} style={{ marginRight: "0.5rem" }} />
            +91 8433630912
          </span>

          <span
            onClick={() => (window.location.href = "tel:9134338897")}
            style={{ cursor: "pointer" }}
          >
            <Phone size={16} style={{ marginRight: "0.5rem" }} />
            +91 9134338897
          </span>
        </div>
      </div>

      <header className="hob-header">
        <div className="hob-header__logo" onClick={() => navigateTo("/")}>
          <img className="logo-width" src={logo} />
        </div>

        <nav className={`hob-header__nav ${drawerOpen ? "active" : ""}`}>
          <span onClick={() => navigateTo("/")}>Home</span>
          <span onClick={() => navigateTo("/about-us")}>About</span>

          <div
            className="hob-header__nav-services"
            onMouseEnter={() => setShowServices(true)}
            onMouseLeave={() => setShowServices(false)}
          >
            <span onClick={() => navigateTo("/service")}>Services</span>
            {/* {showServices && (
                            <ul className="hob-header__nav-services-dropdown">
                                <li onClick={() => navigateTo("/chimney-repair-service")}>Chimney Repair Service</li>
                                <li onClick={() => navigateTo("/hob-repair-service")}>Hob Repair Service</li>
                                <li onClick={() => navigateTo("/cooking-range-service")}>Cooking Range Service</li>
                                <li onClick={() => navigateTo("/gas-stove-repair-service")}>Gas Stove Repair</li>
                                <li onClick={() => navigateTo("/cook-repair-service")}>Cooktop Repair Service</li>
                                <li onClick={() => navigateTo("/gas-service-repair-service")}>Gas Service</li>
                            </ul>
                        )} */}
          </div>
          {/*<span onClick={() => navigateTo("/gallery")}>Gallery</span>*/}
          <span onClick={() => navigateTo("/contact-us")}>Contact</span>
        </nav>

        <button
          className="hob-header__call-button"
          onClick={() => (window.location.href = "tel:8433630912")}
          style={{ cursor: "pointer" }}
        >
          <Phone size={18} style={{ marginRight: "0.5rem" }} />
          Call Now
        </button>

        {/* hob-Hamburger icon for mobile */}
        <div className="hob-hamburger-icon" onClick={toggleDrawer}>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </header>

      {/* Drawer navigation */}
      <div className={`hob-drawer ${drawerOpen ? "hob-open" : ""}`}>
        <div className="hob-drawer-content">
          <button className="hob-drawer-close-btn" onClick={toggleDrawer}>
            <X size={20} />
          </button>
          <nav className="hob-header__nav">
            <span onClick={() => navigateTo("/")}>Home</span>
            <span onClick={() => navigateTo("/about-us")}>About</span>

            {/* <div className="hob-header__nav-services-mobile">
              <span onClick={() => setShowServices(!showServices)}>
                Services{" "}
                {showServices ? (
                  <ChevronUp size={16} />
                ) : (
                  <ChevronDown size={16} />
                )}
              </span>
              {showServices && (
                <ul className="hob-header__nav-services-dropdown-mobile">
                  <li onClick={() => navigateTo("/chimney-repair-service")}>
                    Chimney Repair Service
                  </li>
                  <li onClick={() => navigateTo("/hob-repair-service")}>
                    Hob Repair Service
                  </li>
                  <li onClick={() => navigateTo("/cooking-range-service")}>
                    Cooking Range Service
                  </li>
                  <li onClick={() => navigateTo("/gas-stove-repair-service")}>
                    Gas Stove Repair
                  </li>
                  <li onClick={() => navigateTo("/cook-repair-service")}>
                    Cooktop Repair Service
                  </li>
                  <li onClick={() => navigateTo("/gas-service-repair-service")}>
                    Gas Service
                  </li>
                </ul>
              )}
            </div> */}

            <span onClick={() => navigateTo("/service")}>Services</span>
            {/*<span onClick={() => navigateTo("/gallery")}>Gallery</span>*/}
            <span onClick={() => navigateTo("/contact-us")}>Contact</span>
          </nav>
          <button
            className="hob-header__call-button-mobile"
            onClick={() => (window.location.href = "tel:8433630912")}
          >
            <Phone size={18} style={{ marginRight: "0.5rem" }} />
            Call Now
          </button>
        </div>
      </div>
    </>
  );
};

export default Header;
